<template>
  <a
    :href="productUrl(product.id)"
    class="product-card-container font-rubik relative flex flex-col justify-end"
  >
    <img
      :src="product.primary_photo"
      :alt="product.name"
      class="max-h-[136px] absolute top-1/2 -translate-y-1/2 left-0 mx-[20px]"
    >
    <span
      v-if="product.name"
      :class="[
        { 'text-[1rem]': product.name.length >= 29 && product.name.length < 36 },
        { 'text-[0.8rem]': product.name.length >= 36 }
      ]"
      class="text-center"
    >
      {{ product.name }}
    </span>
  </a>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    productUrl(productId) {
      return this.product.slug ? `${window.location.pathname}/${this.product.slug}` : this.productIdUrl(productId)
    },
    productIdUrl(productId) {
      const currentUrl = window.location.href
      const baseUrl = currentUrl.substring(0, currentUrl.lastIndexOf('/'))
      const newUrl = `${baseUrl}/products/${productId}`
      return newUrl
    }
  }
}
</script>

<style scoped>
.product-card-container {
  width: 300px;
  height: 344px;
  padding: 20px;
  border: 1px solid #E2E1DE;
  background-color: white;
  border-radius: 12px;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: -0.04em;
  color: black;
  cursor: pointer;
  text-decoration: none;
  overflow: hidden;
}

.product-card-container img {
  object-fit: contain;
  display: block;
}

.product-card-container:hover {
  border-color: #c3c2bf;
}

/* mobile */
@media(max-width: 1024px) {
  .product-card-container {
    margin-left: 20px;
    margin-right: 20px;
    width: auto;
    margin-bottom: 2px;
  }
}
</style>
